import API from "../API";
import { actionPending, actionSuccess, actionError } from "../index";
import { toast } from "react-toastify";
import getHeader from "../header";
import { toastSuccess, toastError } from "../../components/toast/Toast";
import {dateFormat} from "../../helpers/formatter";

export const JOBSPOT_LIST_PENDING = "JOBSPOT_LIST_PENDING";
export const JOBSPOT_LIST_SUCCESS = "JOBSPOT_LIST_PENDING_SUCCESS";
export const JOBSPOT_LIST_ERROR = "JOBSPOT_LIST_PENDING_ERROR";
export const DELETE_JOBSPOT_SUCCESS = "DELETE_JOBSPOT_SUCCESS";
export const DELETE_JOBSPOT_ERROR = "DELETE_JOBSPOT_ERROR";
export const DELETE_JOBSPOT_PENDING = "DELETE_JOBSPOT_PENDING";
export const ADD_JOBSPOT_SUCCESS = "ADD_JOBSPOT_SUCCESS";
export const ADD_JOBSPOT_ERROR = "ADD_JOBSPOT_ERROR";
export const ADD_JOBSPOT_PENDING = "ADD_JOBSPOT_PENDING";
export const EDIT_JOBSPOT_SUCCESS = "EDIT_JOBSPOT_SUCCESS";
export const EDIT_JOBSPOT_ERROR = "EDIT_JOBSPOT_ERROR";
export const EDIT_JOBSPOT_PENDING = "EDIT_JOBSPOT_PENDING";


const JOBSPOT_URL = "master_data/job_spot";
const UPLOAD_IMAGE_JOBSPOT_URL = "image/upload/job_spot";

export function jobSpotList(param = {}, resolve, reject, callback, checklist) {
    return (dispatch) => {
        dispatch(actionPending(JOBSPOT_LIST_PENDING));
        API.post(JOBSPOT_URL+'/find', param, getHeader())
            .then((res) => {
                if (res.error) {
                    throw res.error;
                }
                dispatch(actionSuccess(JOBSPOT_LIST_SUCCESS, res.data));
                const { records_total } = res.data;
                let data = res.data.data.map((item, i) => ({
                    no: i + 1 + (param.page - 1) * param.length,
                    ...item,
                    created_at: dateFormat(item.created_at),
                    posted_range: `${dateFormat(item.published_start_date)} - ${dateFormat(item.published_end_date)}`,
                    records_total: res.data.records_total,
                }));
                if (resolve) {
                    resolve({
                        data: data,
                        page: param.page - 1,
                        totalCount: records_total,
                    });
                }
                if (callback) {
                    callback();
                }
            })
            .catch((error) => {
                dispatch(actionError(JOBSPOT_LIST_ERROR, error));
                if (error.response && error.response.status === 500) {
                    toast.error(error.response.data.message, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                } else {
                    toast.error(error.toString(), {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                }
            });
    };
}

export function addJobSpot({instance_logo, ...param}, callback) {
    return async (dispatch) => {
        dispatch(actionPending(ADD_JOBSPOT_PENDING));
        if (instance_logo){
            let formData = new FormData();
            formData.append("file", instance_logo);
            instance_logo && await API.post(UPLOAD_IMAGE_JOBSPOT_URL, formData, getHeader())
                .then((res) => {
                    param.instance_logo = res.data.filename;
                })
        }
        API.post(JOBSPOT_URL+'/add', param, getHeader())
            .then((res) => {
                if (res.error) {
                    throw res.error;
                }
                dispatch(actionSuccess(ADD_JOBSPOT_SUCCESS, res.data.data));

                if (callback) {
                    callback();
                    toastSuccess("Berhasil Tambah Lowongan");
                }
                return res;
            })
            .catch((error) => {
                dispatch(actionError(ADD_JOBSPOT_ERROR, error));
                toastError(error, "Gagal ");
            });
    };
}

export function editJobSpot({instance_logo, ...param}, callback, type) {
    return async (dispatch) => {
        dispatch(actionPending(EDIT_JOBSPOT_PENDING));
        if (instance_logo){
            let formData = new FormData();
            formData.append("file", instance_logo);
            instance_logo && await API.post(UPLOAD_IMAGE_JOBSPOT_URL, formData, getHeader())
                .then((res) => {
                    param.instance_logo = res.data.filename;
                })
        }
        API.post(JOBSPOT_URL+'/edit', param, getHeader())
            .then((res) => {
                if (res.error) {
                    throw res.error;
                }
                dispatch(actionSuccess(EDIT_JOBSPOT_SUCCESS, res.data.data));
                toastSuccess(`Data JobSpot ${param.name} berhasil dirubah.`)
                if (callback) {
                    callback();
                }
                return res;
            })
            .catch((error) => {
                dispatch(actionError(EDIT_JOBSPOT_ERROR, error));
                toastError(error, "Gagal ");
            });
    };
}

export function deleteJobSpot(param, callback, type) {
    return (dispatch) => {
        dispatch(actionPending(DELETE_JOBSPOT_PENDING));
        API.post(JOBSPOT_URL+'/delete', param, getHeader())
            .then((res) => {
                if (res.error) {
                    throw res.error;
                }
                dispatch(actionSuccess(DELETE_JOBSPOT_SUCCESS, res.data.data));

                if (callback) {
                    callback();
                }
                return res;
            })
            .catch((error) => {
                dispatch(actionError(DELETE_JOBSPOT_ERROR, error));
                toastError(error, "Gagal ");
            });
    };
}
